import React, { memo, useEffect } from 'react';

import { LinkButton, useDeviceType } from '@cian/ui-kit';
import { BorderBlock } from '../BorderBlock';
import { ETestIds } from '../../constants';
import { useTracking } from 'shared/mortgageMiniCalculator/utils/tracking/useTracking';

const imgPath = 'https://static.cdn-cian.ru/frontend/mortgage-assets/mortgage_mini_calculator/eye-for-luope.svg';
const linkUrl = 'https://cian.ru/ipoteka/';

export const OfferEmpty: React.FC = memo(() => {
  const { trackShowEmptyListing, trackClickEmptyListingBtn } = useTracking();
  const deviceType = useDeviceType();
  const isMobile = deviceType === 'phone';

  useEffect(() => {
    trackShowEmptyListing();
  }, []);

  return (
    <BorderBlock
      testId={ETestIds.OffersEmpty}
      imgUrl={imgPath}
      title={'Нет подходящих предложений'}
      description={'Попробуйте увеличить первый взнос или срок кредита'}
      button={
        <LinkButton fullWidth={isMobile} href={linkUrl} onClick={trackClickEmptyListingBtn}>
          Подбери свою ипотеку
        </LinkButton>
      }
    />
  );
});

OfferEmpty.displayName = 'OfferEmpty';
